import React from 'react';
import {faSearch as SearchIcon} from '@netx/core-icons';
import {
	IconButton,
	type IconButtonProps,
} from '@netx/core-components/IconButton';
import {i18n} from '@netx/core/i18n';

export interface SearchProps extends Partial<IconButtonProps> {}

export const AttributeSearchPrimitive = (props: SearchProps) => {
	return (
		<IconButton
			data-testid="search"
			aria-label="search by attribute value"
			label={i18n.t('i18n.search')}
			icon={SearchIcon}
			{...props}
		/>
	);
};

export const AttributeSearch = AttributeSearchPrimitive;

export default AttributeSearchPrimitive;
